import React, { useMemo } from 'react';
import axios from 'axios';
import { IoClose } from "react-icons/io5";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

const FilterFeatureDataSimpleModal = ({ globalRefs, globalState }) => {
    const mapMetaData = globalState.mapMetaData;
    const setShowFilterFeatureDataSimpleModal =
        globalState.setShowFilterFeatureDataSimpleModal;
    const setMapMetaData = globalState.setMapMetaData;

    const currentMapIdRef = globalRefs.currentMapIdRef;

    const workingLocally = globalState.workingLocally;
    const devDeployment = globalState.devDeployment;

    const featureDataSimple =
        mapMetaData?.define_feature_data_simple || {};

    const patchFeatureData = async (featureKey, displayOrder) => {
        try {
            const token = localStorage.getItem('token');

            if (!workingLocally && !token) {
                throw new Error('No token in local storage');
            }

            const payload = {
                feature_header: {
                    define_feature_data_simple: {
                        [featureKey]: {
                            display_order: displayOrder
                        }
                    }
                }
            };

            console.log("PATCH PAYLOAD:", payload);

            if (workingLocally) {
                await axios.patch(
                    `http://localhost:3001/api/maps/${currentMapIdRef.current}`,
                    payload,
                    {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: {
                            srid: 4326
                        }
                    }
                );
            } else {
                const url = devDeployment
                    ? `https://harrierapi9697.site/dev/api/maps/${currentMapIdRef.current}/?token=${encodeURIComponent(token)}&srid=4326`
                    : `https://harrierapi9697.site/api/maps/${currentMapIdRef.current}/?token=${encodeURIComponent(token)}&srid=4326`;

                const response = await fetch(url, {
                    method: 'PATCH',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error(`PATCH failed: ${response.status}`);
                }

                await response.json();
            }
        } catch (err) {
            console.error(
                "PATCH failed:",
                err?.response?.data || err
            );
        }
    };

    const toggleFeatureData = (featureKey, currentlyHidden) => {
        const displayOrder = currentlyHidden ? 0 : -1;

        setMapMetaData(prev => {
            const next = structuredClone(prev);

            next.define_feature_data_simple[featureKey] = {
                ...next.define_feature_data_simple[featureKey],
                display_order: displayOrder
            };

            return next;
        });

        patchFeatureData(featureKey, displayOrder);
    };

    const featureData = useMemo(() => {
        const features =
            globalRefs.longstandingGeoJSONRef?.current?.features || [];

        return Object.entries(featureDataSimple)
            .filter(([key]) => key !== 'shortname')
            .map(([key, meta]) => ({
                key,
                meta
            }))
            .filter(item => {
                if (!item.meta || typeof item.meta !== 'object') {
                    return false;
                }

                // Health check:
                // Only show the property if it actually exists
                // in at least one feature's feature_data_simple.
                return features.some(feature => {
                    const featureData =
                        feature?.feature_data_simple;

                    return (
                        featureData &&
                        Object.prototype.hasOwnProperty.call(
                            featureData,
                            item.key
                        )
                    );
                });
            })
            .sort((a, b) => {
                return (a.meta?.name || a.key).localeCompare(
                    b.meta?.name || b.key,
                    undefined,
                    {
                        sensitivity: 'base'
                    }
                );
            });
    }, [featureDataSimple, globalRefs]);

    const renderFeatureData = (key, meta) => {
        const isHidden = meta.display_order === -1;

        return (
            <div
                key={key}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '6px',
                    marginBottom: '6px',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    background: isHidden
                        ? '#f3f3f3'
                        : '#fff',
                }}
            >
                <span
                    style={{
                        flex: 1,
                        color: isHidden
                            ? '#999'
                            : '#222',
                    }}
                >
                    {meta?.name || key}
                </span>

                <button
                    onClick={() =>
                        toggleFeatureData(key, isHidden)
                    }
                    style={{
                        border: 'none',
                        background: 'none',
                        padding: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        fontSize: '20px',
                        color: isHidden
                            ? '#999'
                            : '#222',
                    }}
                    title={
                        isHidden
                            ? 'Show feature data'
                            : 'Hide feature data'
                    }
                >
                    {isHidden
                        ? <IoMdEyeOff />
                        : <IoMdEye />
                    }
                </button>
            </div>
        );
    };

    return (
        <div
            style={{
                width: '320px',
                maxHeight: '500px',
                overflowY: 'auto',
                backgroundColor: '#fff',
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 10000000,
                borderRadius: '6px',
                padding: '12px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <h4 style={{ margin: 0 }}>
                    Properties Filter
                </h4>

                <button
                    onClick={() =>
                        setShowFilterFeatureDataSimpleModal(false)
                    }
                    style={{
                        border: 'none',
                        background: 'none',
                        cursor: 'pointer'
                    }}
                >
                    <IoClose />
                </button>
            </div>

            <h4 style={{ marginTop: 10 }}>
                Info
            </h4>

            {featureData.map(({ key, meta }) =>
                renderFeatureData(key, meta)
            )}
        </div>
    );
};

export default FilterFeatureDataSimpleModal;